<div class="profile-picture-wrapper">

  @if (!readMode) {
    <a (click)="open(content)" class="profilePicOpenModal">
      <ng-container *ngTemplateOutlet="pictures"></ng-container>
    </a>
  } @else {
    @if (!hasProfilePicture && !newImageSelected) {
      <div class="profile-avatar-placeholder">
        <fa-icon [icon]="faUser" size="3x"></fa-icon>
      </div>
    }
    @if (hasProfilePicture && !newImageSelected) {
      <img [src]="profilePictureUrl" class="profile-avatar-img" alt="Profile picture">
    }
    @if (newImageSelected) {
      <img [src]="imageShow" class="profile-avatar-img" alt="Profile picture">
    }
  }

</div>


<ng-template #pictures>
  @if (!hasProfilePicture && !newImageSelected) {
    <div class="profile-avatar-placeholder">
      <fa-icon [icon]="faUser" size="3x"></fa-icon>
    </div>
  }

  @if (hasProfilePicture && !newImageSelected) {
    <img [src]="profilePictureUrl" class="profile-avatar-img" alt="Profile picture">
  }

  @if (newImageSelected) {
    <img [src]="imageShow" class="profile-avatar-img" alt="Profile picture">
  }
</ng-template>

<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Profile Picture</h4>
    <button type="button" class="btn-close" aria-label="Close"
      (click)="d('Cross click')">
    </button>
  </div>
  <div class="modal-body">
    <div class="modal-avatar-preview">
      @if (!hasModelPicture && !hasProfilePicture) {
        <div class="profile-avatar-placeholder profile-avatar-placeholder--lg">
          <fa-icon [icon]="faUser" size="5x"></fa-icon>
        </div>
      }
      @if (hasModelPicture) {
        <img [src]="imageShow" class="profile-avatar-img profile-avatar-img--lg" alt="Profile picture preview">
      }
      @if (hasProfilePicture && !hasModelPicture) {
        @if (hasProfilePicture && !newImageSelected) {
          <img [src]="profilePictureUrl" class="profile-avatar-img profile-avatar-img--lg" alt="Profile picture">
        }
      }
    </div>

    <div class="modal-upload-action">
      <label for="file-upload" class="btn btn-obrame-primary">
        <fa-icon [icon]="faUpload"></fa-icon> Select a Picture
      </label>
      <input id="file-upload" type="file" accept="image/*" (change)="onFileChanged($event)" />
    </div>

    @if (progress > 0 && progress < 100) {
      <div class="upload-progress">
        <div class="upload-progress-bar" [style.width.%]="progress"></div>
        <span class="upload-progress-text">{{ progress }}%</span>
      </div>
    }

    @if (message) {
      <p class="upload-message">{{ message }}</p>
    }

  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-obrame-primary" (click)="onSaveButton()" [disabled]="isLoading">
      Save
      @if (isLoading) {
        <span class="spinner-border spinner-border-sm ms-2" role="status" aria-hidden="true"></span>
      }
    </button>
  </div>
</ng-template>